import { LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import { GetErrorMessageByExceptionCode, GetMessageExceptionCode } from "@/helper/shareHelper";
import { SetHeaderTableUser, SetTapsUserTable } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import { ConvertToUserDetail, ConvertToUserTable } from "@/service/user/userFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import textHelper from "../../helper/textHelper";

@Module({ namespaced: true })
export default class User extends VuexModule {
  private userTable: Array<any> = [];
  private userTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private headerUserTable: Array<any> = [];
  private tapsUserTable: Array<any> = SetTapsUserTable();
  private isHaveSupportUser = true;
  private removeUserLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private userDetail: any | null = null;
  private userDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private updateUserRoleLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private addNewUserLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private invitationId: number | null = null;
  private setForgotPwdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private forgotPwdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private resetForgotPwdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private forgotPwd: any | null = null;
  private lastestUpdateDatetime: any | null = null;

  get getUserTable(): Array<any> {
    return this.userTable;
  }

  get getUserTableLoadingStatus(): LoadingStatusType {
    return this.userTableLoadingStatus;
  }

  get getHeaderUserTable(): Array<any> {
    return this.headerUserTable;
  }

  get getTapsUserTable(): Array<any> {
    return this.tapsUserTable;
  }

  get getIsHaveSupportUser(): boolean {
    return this.isHaveSupportUser;
  }

  get getRemoveUserLoadingStatus(): LoadingStatusType {
    return this.removeUserLoadingStatus;
  }

  get getUserDetail(): any {
    return this.userDetail;
  }

  get getUserDetailLoadingStatus(): LoadingStatusType {
    return this.userDetailLoadingStatus;
  }

  get getUpdateUserRoleLoadingStatus(): LoadingStatusType {
    return this.updateUserRoleLoadingStatus;
  }

  get getAddNewUserLoadingStatus(): LoadingStatusType {
    return this.addNewUserLoadingStatus;
  }

  get getInvitationId(): number | null {
    return this.invitationId;
  }

  get getSetForgotPwdLoadingStatus(): LoadingStatusType {
    return this.setForgotPwdLoadingStatus;
  }

  get getForgotPwdLoadingStatus(): LoadingStatusType {
    return this.forgotPwdLoadingStatus;
  }

  get getForgotPwd(): any {
    return this.forgotPwd;
  }

  get getResetForgotPwdLoadingStatus(): LoadingStatusType {
    return this.resetForgotPwdLoadingStatus;
  }

  get getLastestUpdateDatetime(): any {
    return this.lastestUpdateDatetime;
  }

  @Mutation
  public SetUserTableLoadingStatus(status: LoadingStatusType) {
    this.userTableLoadingStatus = status;
  }

  @Mutation
  public SetUserTable(userTable: any) {
    this.userTable = userTable.userTableDetails;
    this.isHaveSupportUser = userTable.isHaveSupportUser;
    this.lastestUpdateDatetime = userTable.lastestUpdateDatetime;
    this.tapsUserTable[0].length = userTable.allUserCount;
  }

  @Mutation
  public SetHeaderUserTable(sorting: any = null) {
    this.headerUserTable = SetHeaderTableUser();
    if (sorting !== null) {
      this.headerUserTable.forEach((item) => {
        if (item.sortBy == sorting.sortBy) {
          item.sortingType = sorting.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }

  @Mutation
  public SetRemoveUserLoadingStatus(status: LoadingStatusType) {
    this.removeUserLoadingStatus = status;
  }

  @Mutation
  public SetUserDetail(userDetail: any) {
    this.userDetail = userDetail;
  }

  @Mutation
  public SetUserDetailLoadingStatus(status: LoadingStatusType) {
    this.userDetailLoadingStatus = status;
  }

  @Mutation
  public SetUpdateUserRoleLoadingStatus(status: LoadingStatusType) {
    this.updateUserRoleLoadingStatus = status;
  }

  @Mutation
  public SetAddNewUserLoadingstatus(status: LoadingStatusType) {
    this.addNewUserLoadingStatus = status;
  }

  @Mutation
  public SetInvitationId(invitationId: number | null) {
    this.invitationId = invitationId;
  }

  @Mutation
  public SetForgotPwdLoadingStatus(status: LoadingStatusType) {
    this.setForgotPwdLoadingStatus = status;
  }

  @Mutation
  public SetGetForgotPwdLoadingStatus(status: LoadingStatusType) {
    this.forgotPwdLoadingStatus = status;
  }

  @Mutation
  public SetForgotPwd(forgotPwd: any) {
    this.forgotPwd = forgotPwd;
  }

  @Mutation
  public SetResetForgotPwdLoadingStatus(status: LoadingStatusType) {
    this.resetForgotPwdLoadingStatus = status;
  }

  @Action
  public DoGetUserTable(input: any) {
    if (this.userTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUserTableLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoGetSettingUserTable(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const userTable = ConvertToUserTable(res.data.userTable);
          this.context.commit("SetUserTable", userTable);
          this.context.commit("SetHeaderUserTable", {
            sortBy: input.transactionTableView,
            sortingType: input.tableSorting,
          });
        } else {
          const userTable = {
            isHaveSupportUser: false,
            userTableDetails: [],
            allUserCount: 0,
          };
          this.context.commit("SetHeaderUserTable", {
            sortBy: input.transactionTableView,
            sortingType: input.tableSorting,
          });
          this.context.commit("SetUserTable", userTable);
        }
        this.context.commit("SetUserTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoRemoveUser(input: any) {
    if (this.removeUserLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetRemoveUserLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoRemoveUser(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: input.merchantName
                ? i18n.t("Leave_Organization_MerchantName_Success", { merchantName: input.merchantName })
                : i18n.t("Delete_User_Complete"),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetRemoveUserLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetUserDetail(userId: number) {
    if (this.userDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUserDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.UserService.DoGetUserDetail(userId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const userDetail = ConvertToUserDetail(res.data.userRole);
          this.context.commit("SetUserDetail", userDetail);
        }
        this.context.commit("SetUserDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoUpdateUserRole(input: any) {
    if (this.updateUserRoleLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateUserRoleLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoUpdateUserRole(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Edited_Setting_Success", { name: i18n.t("User") }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateUserRoleLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoAddNewUser(userRoleDetail: any) {
    if (this.addNewUserLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetAddNewUserLoadingstatus", LoadingStatusType.Loading);
      API.UserService.DoAddNewUser(userRoleDetail).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetInvitationId", res.data.invitationId);
        } else {
          const alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetAddNewUserLoadingstatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoSetForgotPwd(username: string) {
    this.context.commit("SetForgotPwdLoadingStatus", LoadingStatusType.Loading);
    API.UserService.DoSetForgotPwd(username).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetForgotPwdLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("SetForgotPwdLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }

  @Action
  public DoGetForgotPwd(input: any) {
    this.context.commit("SetGetForgotPwdLoadingStatus", LoadingStatusType.Loading);
    const _input: any = {
      forgotPwdId: input.a,
      forgotPwdCode: input.b,
    };
    API.UserService.DoGetForgotPwd(_input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetForgotPwd", res.data.forgotPwd);
        this.context.commit("SetGetForgotPwdLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("SetGetForgotPwdLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }

  @Action
  public DoResetPwd(password: string) {
    this.context.commit("SetResetForgotPwdLoadingStatus", LoadingStatusType.Loading);
    const passwordToken = textHelper.CreateToken(password);
    const input = {
      forgotPwdId: this.forgotPwd.id,
      forgotPwdCode: this.forgotPwd.forgotPwdCode,
      password: passwordToken,
    };
    API.UserService.DoResetPwd(input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetResetForgotPwdLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("SetResetForgotPwdLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }
}
